/**
 * typography constants for the Serenity app
 * Provides consistent font styling across all components
 *
 * USAGE: Use the custom Text component from '../components/Text' instead of React Native's Text.
 * The custom Text component automatically applies Inter font family and provides convenient props.
 */
export const typography = {
  // Font families
  fontFamily: {
    regular: "Inter_400Regular",
    medium: "Inter_500Medium",
    semiBold: "Inter_600SemiBold",
    bold: "Inter_700Bold",
    // Default font family for the entire app
    default: "Inter_400Regular"
  },

  // Symbol font families (Material Symbols)
  symbolFamily: {
    regular: "MaterialSymbolsOutlined_400Regular",
    medium: "MaterialSymbolsOutlined_500Medium",
    semiBold: "MaterialSymbolsOutlined_600SemiBold",
    bold: "MaterialSymbolsOutlined_700Bold",
    // Default font family for the entire app
    default: "MaterialSymbolsOutlined_400Regular"
  },

  // Font sizes
  fontSizes: {
    xsmall: 12,
    small: 14,
    medium: 16,
    large: 18,
    xlarge: 22
  },

  // Symbol sizes (larger than text to maintain visual balance)
  symbolSizes: {
    small: 18,
    medium: 20,
    large: 24,
    xlarge: 28
  },

  // Line heights
  lineHeights: {
    tight: 1.2,
    normal: 1.4,
    relaxed: 1.6
  }
} as const;
